import React from 'react'

import PropTypes from 'prop-types'

import AtomRadioButton from '@s-ui/react-atom-radio-button'

const SortOption = ({label, isChecked, onSelectOption}) => (
  <li className="mt-SearchSort-option" onClick={onSelectOption} aria-label={label}>
    <AtomRadioButton id={label} value={label} label={label} name="sort" checked={isChecked} />
    <span className="mt-SearchSort-optionText">{label}</span>
  </li>
)

SortOption.displayName = 'SortOption'
SortOption.propTypes = {
  label: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onSelectOption: PropTypes.func.isRequired
}

export default React.memo(SortOption)
